"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdministratorEmailDto = void 0;
class AdministratorEmailDto {
}
exports.AdministratorEmailDto = AdministratorEmailDto;
//# sourceMappingURL=administrator-email.dto.js.map